import { Controller } from "@hotwired/stimulus";
import { FrameElement } from "@hotwired/turbo";

export default class extends Controller<HTMLElement> {
  declare spinnerElement?: HTMLElement;
  declare boundShow: (ev: Event) => void;
  declare boundHide: (ev: Event) => void;

  connect(): void {
    // bind handlers so we can remove them later
    this.boundShow = this.showSpinner.bind(this);
    this.boundHide = this.hideSpinner.bind(this);

    const turboFrame = this.element as FrameElement;
    turboFrame.addEventListener("turbo:before-fetch-request", this.boundShow);
    turboFrame.addEventListener("turbo:before-fetch-response", this.boundHide);
  }

  disconnect(): void {
    const turboFrame = this.element as FrameElement;
    turboFrame.removeEventListener(
      "turbo:before-fetch-request",
      this.boundShow
    );
    turboFrame.removeEventListener(
      "turbo:before-fetch-response",
      this.boundHide
    );
    this.removeSpinner();
  }

  showSpinner(_: Event): void {
    const turboFrame = this.element as HTMLElement;

    // avoid adding multiple spinners
    if (turboFrame.querySelector("[data-frame-spinner]")) return;

    const overlay = document.createElement("div");
    overlay.setAttribute("data-frame-spinner", "");
    overlay.className = "budgeter-frame-spinner";

    const spinner = document.createElement("div");
    spinner.className = "budgeter-spinner budgeter-spinner--frame";
    spinner.setAttribute("role", "status");

    overlay.appendChild(spinner);

    // prepend so we don't replace existing content
    if (turboFrame.firstChild) {
      turboFrame.insertBefore(overlay, turboFrame.firstChild);
    } else {
      turboFrame.appendChild(overlay);
    }

    this.spinnerElement = overlay;
  }

  hideSpinner(_: Event): void {
    this.removeSpinner();
  }

  removeSpinner(): void {
    if (!this.spinnerElement) return;

    const parent = this.spinnerElement.parentElement;
    if (parent) {
      parent.removeChild(this.spinnerElement);
    }
    this.spinnerElement = undefined;
  }
}
